import { useCallback, useEffect } from 'react';

import useScrollProgress from '@/hooks/useScrollProgress';

import { HeaderState } from './types';

export const useLessonMainContent = (
  customDuration: number,
  scrollResult: ReturnType<typeof useScrollProgress>,
  isBannerVisible: boolean,
  setHeaderState: (value: HeaderState) => void,
  editorDoc: any,
  addCurrentLessonTime: () => void,
  contentPerformance?: Record<string, any>,
) => {
  const { scrollProgress, direction } = scrollResult;

  useEffect(() => {
    if (scrollProgress <= 0) {
      //in safari, scrollProgress can be negative
      setHeaderState(isBannerVisible ? HeaderState.Transparent : HeaderState.Standard);
      return;
    }
    switch (direction) {
      case 'down':
        setHeaderState(HeaderState.Hidden);
        break;
      default:
        setHeaderState(isBannerVisible ? HeaderState.Transparent : HeaderState.Standard);
    }
  }, [direction, isBannerVisible, scrollProgress, setHeaderState]);

  const lessonDurationLeft =
    (customDuration ? customDuration : editorDoc?.attrs?.duration ?? 0) *
    ((100 - scrollProgress) / 100);

  const getNodePerformance = useCallback(
    (id: string) => {
      return contentPerformance ? contentPerformance[id] : {};
    },
    [contentPerformance],
  );

  const intervalCallback = useCallback(() => {
    //check if course tab is in focus
    if (document.visibilityState === 'visible') {
      addCurrentLessonTime();
    }
  }, [addCurrentLessonTime]);

  return { lessonDurationLeft, getNodePerformance, intervalCallback };
};

export default useLessonMainContent;
